"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var PageComparator = /** @class */ (function (_super) {
    __extends(PageComparator, _super);
    function PageComparator($view) {
        var _this = _super.call(this, $view) || this;
        _this.$checkbox = _this.$view.find("input[name='show_diff']");
        _this.initListener();
        return _this;
    }
    PageComparator.prototype.initListener = function () {
        var _this = this;
        console.log(this.$checkbox);
        this.$checkbox.on('change', function () {
            console.log(('in'), _this.$checkbox.prop('checked'));
            if (_this.$checkbox.prop('checked')) {
                _this.addActiveClass();
            }
            else {
                PageComparator.removeActiveClass();
            }
        });
    };
    PageComparator.prototype.allEqual = function (arr) {
        return arr.every(function (v) { return v === arr[0]; });
    };
    PageComparator.prototype.addActiveClass = function () {
        var ob = this;
        $('.details-desc').each(function () {
            var line = $(this);
            var vals = [];
            line.find('.details-desc_item').each(function () {
                vals.push($(this).html());
            });
            if (ob.allEqual(vals)) {
                line.removeClass('active');
            }
            else {
                line.addClass('active');
            }
        });
    };
    PageComparator.removeActiveClass = function () {
        $('.details-desc').removeClass('active');
    };
    return PageComparator;
}(BaseComponent_1.default));
exports.default = PageComparator;
